import styled from "@emotion/styled"
import { Button, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import Image from "next/image"
import { useEffect, useRef } from "react"
import { Link } from "utils"
import { FormError } from "../ContactContent"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  padding: 61px 0;
  gap: 32px;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 120px 0;
    gap: 48px;
  }
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 16px;
`

const StyledButton = styled(Button)`
  width: 100%;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 300px;
  }
`

const IdText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export default function Result({
  isFormError,
  id,
}: {
  isFormError: FormError
  id?: string
}) {
  const tInner = useTranslations("InnerPages")
  const tForms = useTranslations("Forms")
  const layoutRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (layoutRef.current) {
      layoutRef.current.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }, [])

  return (
    <StyledLayout ref={layoutRef} role="alert">
      {isFormError === "yes" && (
        <Image
          src={"/icons/formError.svg"}
          width={120}
          height={120}
          alt="failed"
        />
      )}
      {isFormError === "no" && (
        <Image
          src={"/icons/formSuccess.gif"}
          width={200}
          height={200}
          alt="success"
        />
      )}
      {isFormError === "yes" && (
        <TextBox>
          <Typography variant="h3" component={"h1"}>
            {tInner("errorSubmitting")}
          </Typography>
          <Typography variant="body1" component={"h2"}>
            {tInner("canTryAgain")}
          </Typography>
        </TextBox>
      )}
      {isFormError === "no" && (
        <TextBox>
          <Typography variant="h3" component={"h1"}>
            {tInner("thanksForward")}
          </Typography>
          <Typography variant="body1" component={"h2"}>
            {tInner("getBackToYouSoon")}
          </Typography>
        </TextBox>
      )}
      {id && (
        <IdText>
          <Typography variant="body1">{tForms("caseNumber")}:</Typography>
          <Typography variant="body1" fontWeight={700}>
            {id}
          </Typography>
        </IdText>
      )}
      <ButtonContainer>
        {/* {id && (
          <StyledButton variant="primary" onClick={handleLostStatus}>
            סטטוס פניית אבדה
          </StyledButton>
        )} */}
        <StyledButton
          variant={id ? "secondary" : "primary"}
          LinkComponent={Link}
          href="/"
        >
          {tInner("backToHomepage")}
        </StyledButton>
      </ButtonContainer>
    </StyledLayout>
  )
}
